import { Map as ImmutableMap, fromJS } from 'immutable';
import * as SearchFields from 'SalesContentIndexUI/data/constants/SearchFields';
import SearchSortRecord from 'SalesContentIndexUI/data/records/SearchSortRecord';
const sort = field => order => SearchSortRecord({
  field,
  order
});
const SearchSortMap = fromJS(SearchFields).reduce((filterMap, field) => filterMap.set(field, sort(field)), ImmutableMap());
export default ((filterKey, order) => SearchSortMap.get(filterKey)(order));